/**
 * Connects Shopify's standard storefront actions (Shopify.actions) with this theme's cart, so that
 * AI agents (WebMCP) can add to cart and open the cart without reloading the page.
 * - updateCart: runs the standard action, then refreshes the cart drawer and the header cart count.
 * - openCart: opens the cart drawer (or goes to the cart page when the theme uses a cart page).
 */
(() => {
  const configure = () => {
    const actions = window.Shopify && window.Shopify.actions;
    if (!actions || !actions.updateCart || !actions.updateCart.configure) return false;

    const drawer = () => document.querySelector('cart-drawer');
    const cartUrl = () => (window.theme && theme.routes && theme.routes.cart) || '/cart';

    /**
     * Refreshes the cart drawer contents and the cart count in the header.
     */
    const refreshCart = async () => {
      const cartDrawer = drawer();
      if (cartDrawer) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        return;
      }

      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      const response = await fetch(`?sections=cart-icon-bubble`);
      const sections = await response.json();
      const tmpl = document.createElement('template');
      tmpl.innerHTML = sections['cart-icon-bubble'];
      const el = tmpl.content.querySelector('.shopify-section');
      if (el) bubble.innerHTML = el.innerHTML;
    };

    actions.updateCart.configure({
      handler: async (defaultHandler, input, options) => {
        const result = await defaultHandler(input, options);
        if (result && !(result.userErrors || []).length) {
          try {
            await refreshCart();
          } catch (error) {
            console.log(error); // eslint-disable-line
          }
        }
        return result;
      }
    });

    actions.openCart.configure({
      handler: async (defaultHandler, input, options) => {
        const cartType = window.theme && theme.settings && theme.settings.cartType;
        if (drawer() && cartType !== 'page') {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
            detail: { opener: null }
          }));
          return { opened: true };
        }

        if (window.location.pathname !== cartUrl()) window.location.href = cartUrl();
        return { opened: true };
      }
    });

    return true;
  };

  if (configure()) return;

  // The standard actions script may load after the theme scripts: wait for it.
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (configure() || tries > 100) clearInterval(timer);
  }, 100);
})();
